import { useRouter } from 'next/router';

import { DateField, Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'src/lib/ComponentProps';

import { formatDate } from 'src/mappers/fields/parseDate';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import styles from './ContentOverviewDownloadHeader.module.css';

type ContentOverviewDownloadHeaderProps = ComponentProps & {
	fields: {
		DownloadContentDate?: Field<string>;
		PdfCreatedOn?: Field<string>;
		DownloadedFrom?: Field<string>;
		DownloadTerms?: Field<string>;
		LastReviewedLabel?: Field<string>;
		DateOfLastQualityAssuranceReview?: Field<Date>;
	};
};

export default function ContentOverviewDownloadHeader(props: ContentOverviewDownloadHeaderProps): JSX.Element {
	const router = useRouter();
	const isEditing = IsSitecoreEditing();

	if (!isEditing && !props.fields) {
		return <></>;
	}

	return (
		<section className={styles.contentOverviewDownloadHeaderContainer} id="contentOverviewDownloadHeader" data-display-pdf-download>
			<h3 className={styles.downloadHeaderDateText}>{props.fields?.DownloadContentDate?.value}</h3>

			<div className={styles.downloadPDFCreatedOn}>
				<span>{props.fields?.PdfCreatedOn?.value}</span>
				<span>&nbsp;{`${formatDate(new Date())}.`}</span>
			</div>

			<div className={styles.downloadFromText}>
				<span>{props.fields?.DownloadedFrom?.value}</span>
				<span>&nbsp;{`${process.env.PUBLIC_URL + router.asPath}.`}</span>
			</div>

			<span>{props.fields?.DownloadTerms?.value}</span>

			{props.fields.DateOfLastQualityAssuranceReview &&
				new Date(props.fields.DateOfLastQualityAssuranceReview?.value) > new Date('1900-01-01') && (
					<p className={styles.lastReviewedDate}>
						<Text field={props.fields.LastReviewedLabel} />
						<>&nbsp;</>
						<DateField
							field={props.fields.DateOfLastQualityAssuranceReview}
							render={(date: Date) => date && date.toLocaleDateString('en-GB')}
						/>
					</p>
				)}
		</section>
	);
}
